import {BankAccountDomain} from '@dms/api/base';

import {ALL_BANK_ACCOUNT_DOMAINS} from '../constants/ALL_BANK_ACCOUNT_DOMAINS';
import type {BankAccountDomainSelectValue} from '../types/BankAccountDomainSelectValue';

/**
 * Strips the FE-only "All" sentinel before persisting. `['ALL']` becomes `[]`,
 * which the backend treats as "valid for all domains".
 */
export function getRealBankAccountDomains(
  selection: BankAccountDomainSelectValue[]
): BankAccountDomain[] {
  return selection.filter(
    (domain): domain is BankAccountDomain => domain !== ALL_BANK_ACCOUNT_DOMAINS
  );
}
